import { BACKEND_URI } from "../entries";
import { secureAPICall } from "../utils/sessionUtils";

const endpoint = (path) => BACKEND_URI + "/api/warnings/" + path;

export const requestWarnings = async ({ type, employeeId, status, dateFrom, dateTo, q, page = 1, pageSize = 50, verbose = false }) => {
    const formData = new FormData();
    if (q) formData.append("q", q);
    if (type) formData.append("type", type);
    if (employeeId) formData.append("employee_id", employeeId);
    if (status) formData.append("warning_status", status);
    if (dateFrom) formData.append("date_from", dateFrom);
    if (dateTo) formData.append("date_to", dateTo);
    formData.append("page", page);
    formData.append("page_size", pageSize);
    return secureAPICall({ endpoint: endpoint("fetch-warnings"), body: formData, verbose: verbose });
};

// The logged-in employee's own warnings.
export const requestMyWarnings = async ({ type, status, dateFrom, dateTo, page = 1, pageSize = 50, verbose = false }) => {
    const formData = new FormData();
    if (type) formData.append("type", type);
    if (status) formData.append("warning_status", status);
    if (dateFrom) formData.append("date_from", dateFrom);
    if (dateTo) formData.append("date_to", dateTo);
    formData.append("page", page);
    formData.append("page_size", pageSize);
    return secureAPICall({ endpoint: endpoint("fetch-my-warnings"), body: formData, verbose: verbose });
};

export const requestCountNewWarnings = async ({ verbose = false }) => {
    return secureAPICall({ endpoint: endpoint("count-new-warnings"), body: new FormData(), verbose: verbose });
};

export const requestUpdateWarningStatus = async ({ id, status, note = "", verbose = false }) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("warning_status", status);
    formData.append("note", note);
    return secureAPICall({ endpoint: endpoint("update-warning-status"), body: formData, verbose: verbose });
};

export const requestUpdateWarningStatusBulk = async ({ ids, status, note = "", verbose = false }) => {
    const formData = new FormData();
    ids.forEach((id) => formData.append("ids", id));
    formData.append("warning_status", status);
    formData.append("note", note);
    return secureAPICall({ endpoint: endpoint("update-warning-status-bulk"), body: formData, verbose: verbose });
};

export const requestWarningSummary = async ({ verbose = false }) => {
    return secureAPICall({ endpoint: endpoint("fetch-warning-summary"), body: new FormData(), verbose: verbose });
};

export const requestEmployeeWarnings = async ({ userId, verbose = false }) => {
    const formData = new FormData();
    formData.append("user_id", userId);
    return secureAPICall({ endpoint: endpoint("fetch-employee-warnings"), body: formData, verbose: verbose });
};

export const requestCreateManualWarning = async ({ ticketId, messageId, reason, verbose = false }) => {
    const formData = new FormData();
    formData.append("ticket_id", ticketId);
    formData.append("message_id", messageId);
    formData.append("reason", reason);
    return secureAPICall({ endpoint: endpoint("create-manual-warning"), body: formData, verbose: verbose });
};

export const requestWarningSettings = async ({ verbose = false }) => {
    return secureAPICall({ endpoint: endpoint("fetch-warning-settings"), body: new FormData(), verbose: verbose });
};

export const requestSaveWarningSettings = async ({ responseHours, recipients, keywords, keywordRecipients, autoResolve, reminderEnabled, reminderHours, escalationEnabled, escalationHours, noteTemplates = [], verbose = false }) => {
    const formData = new FormData();
    formData.append("response_hours", responseHours);
    formData.append("auto_resolve", autoResolve);
    formData.append("reminder_enabled", reminderEnabled);
    formData.append("reminder_hours", reminderHours);
    formData.append("escalation_enabled", escalationEnabled);
    escalationHours.forEach((h) => formData.append("escalation_hours", h));
    recipients.forEach((r) => formData.append("recipients", r));
    keywords.forEach((k) => formData.append("keywords", k));
    keywordRecipients.forEach((r) => formData.append("keyword_recipients", r));
    // Şablonları her zaman yetkili liste olarak gönder (boş liste = tümünü sil).
    formData.append("manage_note_templates", true);
    noteTemplates.forEach((tpl) => formData.append("note_templates", tpl));
    return secureAPICall({ endpoint: endpoint("save-warning-settings"), body: formData, verbose: verbose });
};
